/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Not_Locked_NudgeInputs */



/**
* | output |
* | --- |
* | "You're offline and this event isn't locked to this device, so changes can't be saved. Reconnect briefly and use Go Offline." |
*
* @param {Offline_Not_Locked_NudgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_not_locked_nudge = /** @type {((inputs?: Offline_Not_Locked_NudgeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Not_Locked_NudgeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous êtes hors ligne et ce tournoi n'est pas verrouillé sur cet appareil : les modifications ne peuvent pas être enregistrées. Reconnectez-vous un instant et utilisez Passer hors ligne.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Está sin conexión y este torneo no está bloqueado en este dispositivo, así que los cambios no se pueden guardar. Reconéctese un momento y use Modo sin conexión.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Você está offline e este torneio não está bloqueado neste dispositivo, então as mudanças não podem ser salvas. Reconecte por um instante e use Ficar offline.")
	if (locale === "it") return /** @type {LocalizedString} */ ("È offline e questo torneo non è bloccato su questo dispositivo, quindi le modifiche non si possono salvare. Si riconnetta un attimo e usi Vai offline.")
	return /** @type {LocalizedString} */ ("You're offline and this event isn't locked to this device, so changes can't be saved. Reconnect briefly and use Go Offline.")
});